<template>
	<transition v-if="products.length" name="fade" mode="out-in">
		<div class="product-tip-display">
			<h2>Har du allt du behöver?</h2>
			<div class="checkbox-group">
				<checkbox
					v-for="n in (showAll ? Number(products.length) : Math.min(2, products.length))"
					v-model="checkboxSelectedProducts[products[n - 1].id]"
					labelSlot
					small
					:key="n + '-product-offers-' + products[n - 1].id"
					@input="ev => toggleSelectedProducts(ev, products[n - 1].id)"
				>
					<ximg
						:src="src(products[n - 1].id)"
						role="img"
						:ariaLabel="products[n - 1].name"
					/>
					<span class="product-title-wrap">
						<fixed-lines
							class="product-list-item-title"
							:useEllipsis="false"
							:lines="1"
							lineHeight="1.2em"
						>
							<product-link
								class="grid-link"
								:product="products[n - 1]"
								@click.native="handleLinkClick(products[n - 1], n - 1)"
							>
								{{ products[n - 1].mainTitle }}
							</product-link>
						</fixed-lines>
						<fixed-lines
							v-if="products[n - 1].subTitle"
							class="sub-title"
							:useEllipsis="false"
							:lines="1"
							lineHeight="1.2em"
						>
							{{ products[n - 1].subTitle }}
						</fixed-lines>
					</span>
					<product-price right :product="products[n - 1]"/>
				</checkbox>
			</div>
			<text-button
				v-if="products.length > 2"
				:text="showAll ? 'Visa färre' : 'Visa fler'"
				linkStyle="fake-link"
				@click="showAll = ! showAll"
			/>
		</div>
	</transition>
</template>

<script>
import store from 'datastore';
import { trackImpression } from 'gtm';

export default {
	store,
	props: {
		product: {
			type: Object,
			required: true,
		},
		bundleOffers: {
			type: Object,
			required: true,
		},
	},
	data () {
		return {
			products: [],
			isBundle: false,
			// for checkbox v-model
			checkboxSelectedProducts: {},
			// for adding to cart
			selectedBundleProducts: [],
			showAll: false,
		};
	},
	mounted () {
		this.updateProducts();
	},
	methods: {
		src (productId) {
			return '/images/product/' + productId + '?trim&h=50';
		},
		updateProducts () {
			this.products = [];
			if (this.bundleOffers.products) {
				this.products = this.bundleOffers.products.filter((value, index, self) =>
					index === self.findIndex((t) => {
						if (t.id === value.id) {
							if (! this.checkboxSelectedProducts?.[value.id]) {
								this.checkboxSelectedProducts[value.id] = false;
							}
							return true;
						}
					})
				)
				this.isBundle = this.bundleOffers.isBundle;
			}
		},
		toggleSelectedProducts (val, id) {
			/* Has to be done this way bc vue reactivity is a silly goose */
			this.checkboxSelectedProducts = Object.assign({}, this.checkboxSelectedProducts, { [id]: val })
		},
		handleLinkClick (product, index) {
			trackImpression([product], 'Product page bundle', {
				rating: true,
				stock: true,
				event: 'select_item',
				position: index
			});
		}
	},
	watch: {
		bundleOffers () {
			this.updateProducts();
		},
		checkboxSelectedProducts (to) {
			const cartProducts = [];
			for (const [key, value] of Object.entries(to)) {
				if (value) {
					const product = this.products.find((prod) => prod.id == key);
					if (product) {
						cartProducts.push(product);
					}
				}
			}
			this.selectedBundleProducts = cartProducts;
		},
		selectedBundleProducts (to) {
			this.$emit('update:selectedBundleProducts', to);
		},
	},
};
</script>
